window.CACHE_REFRESH = function(){
	$('body').append('<div class="modal_success">Chargement...</div>');
	$.ajax({url: BASEPATH + 'widgets/cache_refresh.html'}).done(function( data ) {
		$('.modal_success').text('Cache rafraîchit avec succès !');
		setTimeout(function(){
			$('.modal_success').fadeOut();
		}, 2000);
	});
}

window.export_translation = function(){
	$('body').append('<div class="modal_success">Chargement...</div>');
	$.ajax({url: BASEPATH + 'admin/translation_export'}).done(function() {
		$('.modal_success').text('Export terminé !');
		setTimeout(function(){
			$('.modal_success').fadeOut();
		}, 2000);
	});
}

window.import_translation = function(lng){
	$('body').append('<div class="modal_success">Chargement...</div>');console.debug(BASEPATH + 'admin/translation_import?lng='+lng);
	$.ajax({url: BASEPATH + '/admin/translation_import?lng='+lng}).done(function(data) {
		$('.modal_success').text('Importation des traductions ['+lng.toUpperCase()+'] terminée !');
		setTimeout(function(){
			$('.modal_success').fadeOut();
		}, 2000);
	});
}
window.cleanup_translation = function(lng){
	$('body').append('<div class="modal_success">Chargement...</div>');console.debug(BASEPATH + 'admin/translation_cleanup?lng='+lng);
	$.ajax({url: BASEPATH + '/admin/translation_cleanup?lng='+lng}).done(function(data) {
		$('.modal_success').text('Purge des traductions ['+lng.toUpperCase()+'] terminée !');
		setTimeout(function(){
			$('.modal_success').fadeOut();
		}, 2000);
	});
}

window.swapNodes = function(a, b) {
	var aparent= a.parentNode;
	var asibling= a.nextSibling===b? a : a.nextSibling;
	b.parentNode.insertBefore(a, b);
	aparent.insertBefore(b, asibling);
}

window.getHash = function()
{
	var hash = document.location.hash.substr(2,999);
	if(hash.indexOf('|'))
		return hash.split('|')[0];
	else
		return hash;
}
window.getHashPipe = function()
{
	var hash = document.location.hash.substr(2,999);
	if(hash.indexOf('|'))
		return hash.split('|')[1];
	else
		return null;
}

window.setHash = function(hash)
{
	if (/^#\w+/.test(hash))
		hash = hash.substr(1,999);
	return document.location.hash = '#!'+hash;
}

window.refreshHash = function(e)
{
	if(e) e.preventDefault();

	var hash = '#'+document.location.hash.substr(2,999);
	$('.tabs a[href="'+hash+'"]').trigger('click');
}